/* istanbul ignore file */
import { isMobileAllowed } from '@lumapps/mobile/ducks/selectors';
import { connect } from '@lumapps/redux/react';

import { MobileGeneralSettingsSideNavigation } from './MobileGeneralSettingsSideNavigation';

const mapStateToProps = (state: BackOfficeStore) => {
    const isAllowed = isMobileAllowed(state);

    return {
        isAllowed,
    };
};

const ConnectedMobileGeneralSettingsSideNavigation = connect(mapStateToProps)(MobileGeneralSettingsSideNavigation);

export { ConnectedMobileGeneralSettingsSideNavigation as MobileGeneralSettingsSideNavigation };
